export default __webpack_public_path__ + "static/media/LGBTQ2_fr.afacff82.svg";